import { IpStorageService } from './ip-storage.service';

export default class FreeUsersIpStorage extends IpStorageService { }
